import { render, staticRenderFns } from "./EmployeeCertificationForm.vue?vue&type=template&id=c35d1df6&"
import script from "./EmployeeCertificationForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports